import { render, staticRenderFns } from "./RegisterBasicInformation.vue?vue&type=template&id=7ed19f8c&scoped=true"
import script from "./RegisterBasicInformation.vue?vue&type=script&lang=js"
export * from "./RegisterBasicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed19f8c",
  null
  
)

export default component.exports